module.exports = __webpack_public_path__ + "static/media/mygeotab-logo.acae1055.svg";